import React, { useState, useContext } from "react";
import { Fade } from "react-reveal";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

// Import images once at the top to keep JSX clean
import waveEmoji from "../../assets/images/wave.png";
import profileImg from "../../assets/images/me.jpg";

export default function Greeting() {
  const { isDark } = useContext(StyleContext);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  if (!greeting.displayGreeting) {
    return null;
  }

  return (
    <Fade duration={1000}>
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          
          <div className="greeting-text-div">
            <div>
              <h1 className={`greeting-text ${isDark ? "dark-mode" : ""}`}>
                {greeting.title}{" "}
                <img alt="wave" src={waveEmoji} className="wave-emoji" />
              </h1>
              
              <p className={`greeting-text-p ${isDark ? "dark-mode" : "subTitle"}`}>
                {greeting.subTitle}
              </p>
              
              {/* Note: The empty spacer div was removed! */}
              <SocialMedia />
              
              <div className="button-greeting-div">
                <Button text="Contact Me" href="#contact" />
                {greeting.resumeLink && (
                  <Button 
                    text="View Resume" 
                    href="/resume.pdf" 
                    className="download-link-button" 
                    newTab={true} 
                  />
                )}
              </div>
            </div>
          </div>

          <div className={`greeting-image-div ${isDark ? "dark-mode" : ""}`}>
            {/* Hidden image to preload and detect load completion */}
            <img
              alt="Profile preloader"
              src={profileImg}
              style={{ display: "none" }}
              onLoad={() => setIsImageLoaded(true)}
            />
            {/* Visible image with fade animation (only after load) */}
            {isImageLoaded && (
              <Fade delay={300} duration={800}>
                <img alt="Joseph" src={profileImg} />
              </Fade>
            )}
          </div>

        </div>
      </div>
    </Fade>
  );
}
